import React from "react";
import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

const LOGO_PATH = "/static/images/logo.png";

/**
 * Shared centered-card shell for the MFA screens, matching the look of the
 * email-verification screen.
 */
export const MfaCard = ({
  icon,
  title,
  description,
  error,
  children,
}: {
  icon: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  error?: string | null;
  children: React.ReactNode;
}) => {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center md:bg-gray-100 p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="bg-white p-8 rounded-lg max-w-xl w-full md:border"
      >
        <div className="text-center mb-8">
          <img
            src={LOGO_PATH}
            alt="Saile Company Logo"
            width={150}
            height={60}
            className="mx-auto mb-6"
          />
          <div className="text-primary mb-4 flex justify-center">{icon}</div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">{title}</h1>
          {description && <div className="text-gray-600">{description}</div>}
        </div>

        {error && (
          <Alert variant="destructive" className="mb-6">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        {children}
      </motion.div>
    </main>
  );
};
